import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';
import { Favorite } from 'src/app/models/auth/_models/favorite';
import { LayoutComponentService } from 'src/app/services/layout-component.service';
import { MainHTTPService } from 'src/app/services/main-http/main-http.service';
import { FavoritesService } from 'src/app/services/favorites.service';
import { DxTreeViewComponent, DxTreeViewModule } from 'devextreme-angular';
import {
  CommonService,
  MessagesService,

  PageService,

  SpinnerService
} from '../../../services/service.index';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { ResourceParameter } from 'src/app/services/microapplications/_models/resource-parameter.model';
import { Page } from 'src/app/models/page.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'app-recent',
  templateUrl: './recent.component.html',
  styleUrls: ['./recent.component.scss']
})
export class recentComponent implements OnInit {
  favorites: Favorite[] = [];
  @ViewChild(DxTreeViewComponent) treeView: DxTreeViewComponent;
  tokeshistori: string;
  codigoForm: string;
  listHistorialclick: boolean=false;
  html: SafeResourceUrl;
  public listHistorial = JSON.parse(
    sessionStorage.getItem('listHisotrial') || '[]'
  );
  url: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<SafeResourceUrl>('');

  pagesSe: Page[] = [];


  constructor(private layoutManager: LayoutComponentService, private router: Router,
    private favoritesService: FavoritesService,   private _pageService: PageService, private _commonService: CommonService,  private sanitizer: DomSanitizer,private microapps: MicroapplicationService,  private _messagesService: MessagesService, private _spinnerService: SpinnerService, private mainHttpService: MainHTTPService,private auth:AuthService) { }

  ngOnInit(): void {

    this.favoritesService.getFavorites(Number(this.auth.currentUserValue.selectedCompany.code));
    this.favoritesService.favorites$.subscribe(favorites => {
      if(favorites!=null){
        this.favorites = favorites;
        this.getMainInformation();
      }
      
    })

  }


  getMainInformation() {
    for (let favorite of this.favorites) {
      this.mainHttpService.getMainMenu(favorite.fav_maid).subscribe(menuResult => {
        if (menuResult.isSuccessful && menuResult.result != null) {
          favorite.text = menuResult.result.text,
            favorite.id = menuResult.result.id
        }
      })
    }

  }
  // openMicroApp(itemObj: Favorite) {
  //   if (this.router.url == "/multiview") {
  //     this.layoutManager.layoutManagerAction.next({ id: itemObj.fav_maid, name: itemObj.text })
  //   }
  //   else {
  //     this.router.navigate(['/multiview']).then(() => {
  //       setTimeout(() => {
  //         this.layoutManager.layoutManagerAction.next({ id: itemObj.fav_maid, name: itemObj.text })
  //       }, 1000);

  //     })
  //   }
  // }


  removeClass = (classs: string) => {
    let nodes = document.querySelectorAll(`.${classs}`);
    nodes.forEach(node => {
      node.classList.remove(classs)
    })
  }


  generarPage(node: any, add = true) {
   
    if (add) {
      this.addHistorial(node);
    }
    const page: Page = {
      codProg: node.codigoPrograma,
      name: this.toTitleCase(node.name),
      idForm: node.idForm,
      id: 0,
      url: node.url.toLowerCase(),
      cambiarUrl: true,
      typeForm: node.url.includes('adpro') ? 'adpro' : 'maestro',
      lisnk:null
    };
    this.removeClass('open-item');

    let elemento = document.querySelector(`.sp-menu__link:not(.sp-menu__toggle)[name=${page.codProg}]`) as HTMLElement;
    if (node?.par_prog) page.url = page.url + '&par_prog=' + node.par_prog;
    else {
      this._pageService.generarPage(page);
    }
  }

  toTitleCase(str: string): string {
    // return str
    // console.log(str.toLowerCase().split(' '));

    return str.toLowerCase().split(' ').map((word, i) => {
      if (i == 0) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      } else {
        return word

      }
    }).join(' ');
  }

  hitoriclik(){
   
    if(this.listHistorialclick==false){
      this.listHistorialclick=true
    }
    else{
      this.listHistorialclick=false
    }

  }
  addHistorial(node: any) {
   
    let index = this.listHistorial.findIndex(
      (e: any) => e.idForm == node.idForm
      
    );
    if (index != -1) {
      this.listHistorial.splice(index, 1);
      this.listHistorial.push(node);
    } else {
      this.listHistorial.push(node);
    }

    if (this.listHistorial.length > 3) {
      this.listHistorial = this.listHistorial.slice(
        this.listHistorial.length - 3
      );
    }
    sessionStorage.setItem('listHisotrial', JSON.stringify(this.listHistorial));
  }

  GetGlobalVariables(param: ResourceParameter) {
    if (param.type == 0) {
      return param.value;
    } else {
      switch (param.code) {
        case "token":
          return this.auth.getAuthFromLocalStorage().accessToken;
        case "companyCode":
          return this.auth.currentUserValue.selectedCompany.code;
      }
    } return null
  }
  // itemClick(e) {    

  //   let mainItem  = e.itemData;  
  //   this.favoritesService.deleteFavorite(mainItem.id);

  // }



}
